import Section from "@/components/site/Section";
import Icon from "@/components/site/Icon";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/primitives";
import { PROBLEMS } from "@/lib/content";

export default function ProblemSection() {
  return (
    <Section data-testid="problem-section">
      <Reveal className="max-w-3xl">
        <SectionHeading overline="The Old Roadside Stop" title={<>Charging shouldn't<br />feel like a chore.</>} />
        <p className="mt-6 text-base leading-relaxed text-white/55">
          EV charging can require drivers to wait 30–60+ minutes. Yet too many charging locations still
          leave you with nowhere comfortable to spend that time.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:mt-16">
        {PROBLEMS.map((p, i) => (
          <Reveal key={p.title} delay={(i % 3) * 0.06}>
            <div className="h-full rounded-2xl border border-white/10 bg-rp-card p-6 md:p-7" data-testid={`problem-${i}`}>
              <Icon name={p.icon} className="h-6 w-6 text-white/40" strokeWidth={1.5} />
              <h3 className="mt-5 font-display text-lg font-medium tracking-tight text-white">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/55">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
